import { Immutable, SB } from '@play-co/replicant';

const evolutions = SB.object({
  species: SB.string(),
  stage: SB.string(),
  timestamp: SB.int(),
});

const deathRecord = SB.object({
  type: SB.tuple(['death']),
  name: SB.string(),
  species: SB.string(),
  age: SB.int(),
  evolutions: SB.array(evolutions),
  timestamp: SB.int(),
});

const duoRecord = SB.object({
  type: SB.tuple(['duo']),
  name: SB.string(),
  species: SB.string(),
  age: SB.int(),
  evolutions: SB.array(evolutions),
  friendID: SB.string(),
  timestamp: SB.int(),
});

const duoFriendRecord = SB.object({
  type: SB.tuple(['duoFriend']),
  name: SB.string(),
  species: SB.string(),
  age: SB.int(),
  friendID: SB.string(),
  timestamp: SB.int(),
});

// Type for one futureStatusEffects record
export type DeathRecordType = SB.ExtractType<typeof deathRecord>;
export type DuoRecordType = SB.ExtractType<typeof duoRecord>;
export type DuoFriendRecordType = SB.ExtractType<typeof duoFriendRecord>;
export type StateHistoryRecord = Immutable<
  DeathRecordType | DuoRecordType | DuoFriendRecordType
>;

export default {
  history: SB.array(SB.union([deathRecord, duoRecord, duoFriendRecord])),
};
